var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-blank",class:{'blank-sp': _vm.$store.state.screen == 1}},[_c('img',{attrs:{"src":require("images/blank.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }